interface ContentSectionProps {
  children: React.ReactNode;
  className?: string;
  variant?: "light" | "dark" | "accent";
  id?: string;
}

const variantStyles = {
  light: "bg-background text-foreground",
  dark: "bg-secondary on-dark text-foreground",
  accent: "bg-primary text-primary-foreground",
};

const ContentSection = ({ children, className = "", variant = "light", id }: ContentSectionProps) => {
  return (
    <section id={id} className={`py-24 md:py-32 ${variantStyles[variant]} ${className}`}>
      <div className="mx-auto max-w-wide px-5 md:px-12">
        {children}
      </div>
    </section>
  );
};

export default ContentSection;
